<template>
  <section>
    <v-container id="container">
      <v-row id="contacto">
        <v-col cols="12" md="6" align-self="center" class="mt-15">
          <v-img
            contain
            height="500"
            class="pa-15"
            src="@/assets/vect/email.svg"
          >
          </v-img>
        </v-col>
        <v-col cols="12" md="6">
          <v-container class="fill-height">
            <v-row justify="center" class="mb-5 my-md-15">
              <v-col cols="11" md="8" class="py-0">
                <h2 class="font-weight-bold mb-4 primary--text">
                  {{ $t("contacto.titulo") }}
                </h2>
                <p class="font-weight-light mt-4 primary--text">
                  {{ $t("contacto.texto") }}
                </p>

                <!-- <v-row justify="center">
                 <v-icon color="secondary">mdi-email
                  </v-icon>  
                 <h1 class="text-center secondary--text pl-3">
                   info@ebersy.com
                 </h1>
               </v-row>   -->
              </v-col>
              <v-col cols="11" md="8" class="py-0">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  methods="post"
                  action="@/php/formulario.php"
                >
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :label="$t('contacto.nombre')"
                    required
                    name="nombre"
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                    name="email"
                  ></v-text-field>

                  <!-- <v-select
                  v-model="select"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  required
                ></v-select> -->

                  <v-textarea
                    v-model="textarea"
                    :rules="textareaRules"
                    outlined
                    clearable
                    dense
                    background-color="white"
                    name="mensaje"
                    :label="$t('contacto.mensaje')"
                    rows="3"
                    auto-grow
                  >
                  </v-textarea>

                  <div class="d-flex align-center flex-wrap">
                    <v-checkbox
                      v-model="checkbox"
                      :rules="[(v) => !!v]"
                      color="azul"
                    ></v-checkbox>
                    <p class="pt-4 text-caption">
                      {{ $t("contacto.acepto") }}
                      <router-link
                        class="azul--text text-decoration-none"
                        to="Legal"
                        >{{ $t("info.aviso") }}
                      </router-link>
                      y
                      <router-link
                        class="azul--text text-decoration-none"
                        to="Politica"
                        >{{ $t("info.privacidad") }}
                      </router-link>
                    </p>
                  </div>
                  <v-btn @click="submit" block dark class="boton">{{
                    $t("contacto.enviar")
                  }}</v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="verdeOscuro py-15" fluid>
      <v-row justify="center" align="center" class="py-5">
        <v-col cols="11" class="ma-auto">
          <v-row justify="center">
            <v-col v-scrollanimation cols="12" md="3" class="anim">
              <v-img contain>
                <svg
                  id="Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <rect
                    id="Area"
                    width="20"
                    height="20"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g
                    id="Icon-2"
                    data-name="Icon"
                    transform="translate(1.29 2.499)"
                  >
                    <path
                      id="Path"
                      d="M3.333,3.333H16.667A1.671,1.671,0,0,1,18.333,5V15a1.671,1.671,0,0,1-1.666,1.667H3.333A1.671,1.671,0,0,1,1.667,15V5A1.671,1.671,0,0,1,3.333,3.333Z"
                      transform="translate(-1.29 -2.499)"
                      fill="none"
                      stroke="#3d3d3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                    <path
                      id="Path-2"
                      data-name="Path"
                      d="M18.333,5,10,10.833,1.667,5"
                      transform="translate(-1.29 -2.499)"
                      fill="none"
                      stroke="#3d3d3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3>Email</h3>
                <a href="mailto:info@ntecweb.es"
                  ><p class="white--text">info@ntecweb.es</p></a
                >
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="3" class="anim">
              <v-img contain>
                <svg
                  id="Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <rect
                    id="Area"
                    width="20"
                    height="20"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g
                    id="Icon-2"
                    data-name="Icon"
                    transform="translate(1.29 2.499)"
                  >
                    <path
                      id="Path"
                      d="M18.333,14.1v2.5a1.667,1.667,0,0,1-1.816,1.667,16.488,16.488,0,0,1-7.192-2.559,16.24,16.24,0,0,1-5-5A16.488,16.488,0,0,1,1.767,3.483,1.667,1.667,0,0,1,3.425,1.667h2.5A1.666,1.666,0,0,1,7.592,3.1a10.68,10.68,0,0,0,.583,2.342A1.665,1.665,0,0,1,7.8,7.2L6.742,8.258a13.319,13.319,0,0,0,5,5L12.8,12.2a1.665,1.665,0,0,1,1.758-.375,10.68,10.68,0,0,0,2.342.583A1.667,1.667,0,0,1,18.333,14.1Z"
                      transform="translate(-1.29 -2.499)"
                      fill="none"
                      stroke="#3d3d3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3>{{ $t("info.telefono") }}</h3>
                <p class="white--text">
                  948482356
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="3" class="anim">
              <v-img contain>
                <svg
                  id="Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <rect
                    id="Area"
                    width="20"
                    height="20"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g
                    id="Icon-2"
                    data-name="Icon"
                    transform="translate(1.29 2.499)"
                  >
                    <path
                      id="Path"
                      d="M17.5,8.333c0,5.834-7.5,10.834-7.5,10.834s-7.5-5-7.5-10.834a7.5,7.5,0,1,1,15,0Z"
                      transform="translate(-1.29 -2.499)"
                      fill="none"
                      stroke="#3d3d3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                    <circle
                      id="Path-2"
                      data-name="Path"
                      cx="2.5"
                      cy="2.5"
                      r="2.5"
                      transform="translate(6.21 3.334)"
                      fill="none"
                      stroke="#3d3d3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3>{{ $t("info.direccion") }}</h3>
                <p class="white--text">
                  Pol.Mutilva E-1, Planta baja. Oficina 0D 31192 (Navarra)
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="mapa">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11711.928169967843!2d-1.6236093!3d42.7887295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x61fdad3bdb2c1605!2sUrdi%20Nuevas%20Tecnolog%C3%ADas%2C%20S.L.!5e0!3m2!1ses!2ses!4v1624284012363!5m2!1ses!2ses"
        width="100%"
        height="450"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    name: "",
    nameRules: [(v) => !!v],
    email: "",
    emailRules: [(v) => !!v, (v) => /.+@.+\..+/.test(v)],
    select: null,
    textareaRules: [(v) => !!v],
    checkbox: false,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        console.log(this.name, this.email, this.mensaje);
      }
    },
  },
};
</script>

<style scoped>
#contacto {
  min-height: 100vh;
}
* {
  text-decoration: none !important;
}
</style>
